"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    tpl: {
        col: {
            horizontal: 50,
            vertical: 50
        }
    },
    theme: {
        width: 0,
        height: 0,
        color: "#fff",
        background: null,
        padding: 0
    }
};
//# sourceMappingURL=page.js.map